import { createStore, Store } from "easy-peasy";
import { model, StoreModel } from "./model";
import { firebase } from "../helpers/fbase";
import { reactReduxFirebase } from "react-redux-firebase";
import { logger } from "../middleware/logger.middleware";

const isDevEnv =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

const rrfConfig = {
  firebase,
  config: {},
};

const epStore: Store<StoreModel> = createStore(model, {
  middleware: isDevEnv ? [logger] : undefined,
  enhancers: [reactReduxFirebase(firebase, rrfConfig)],
});

// Wrapping dev only code like this normally gets stripped out by bundlers
// such as Webpack when creating a production build.
if (process.env.NODE_ENV === "development") {
  if ((module as any).hot) {
    (module as any).hot.accept("./model", () => {
      epStore.reconfigure(model); // 👈 Here is the magic
    });
  }
}

export { epStore };
